export enum AllocationSystems {
    RUC = 1,
    GAP = 2,
    LOI = 3,
    OES = 4,
}
